export default `
  font-size: 12px;
  font-weight: 500;
`
